import ImportListProductShippingSelector from './ImportListProductShippingSelector'

export default ImportListProductShippingSelector
